import gql from "graphql-tag";

export const INSERT_CUSTOMER = gql`
mutation insert_Customer($id:uuid!,$name:String!,$mobile:String,$email:String,$phone:String,$city:String,$companyName:String, $orgId:uuid!){
  insert_Customer(objects: {id:$id, name:$name, mobile:$mobile, email:$email,phone:$phone,city:$city,companyName:$companyName, orgId:$orgId}){
    returning{
      id
    }
  }
}`

export const UPDATE_CUSTOMER = gql`
mutation($id:uuid!,$name:String!,$mobile:String,$email:String,$phone:String,$city:String,$companyName:String, $orgId:uuid!){
  update_Customer(where:{id:{_eq:$id}}, _set:{name:$name, mobile:$mobile, email:$email,phone:$phone,city:$city,companyName:$companyName, orgId:$orgId}){
    returning{
      id
    }
  }
}`

/* --------------- Missing Retail Sales Entry ------------------ */
export const UPSERT_CUSTOMER_AND_INSERT_RETAIL_SALES = gql`                   
mutation retailSalesEntry($order:[Orders_insert_input!]!, $orderItems:[OrderItems_insert_input!]!,
                     $customer:[Customer_insert_input!]!) {
  insert_Customer(objects: $customer, on_conflict: {constraint: Customer_pkey, update_columns: []}){
    returning{id}
  }                   
  insert_Orders(objects: $order){
   affected_rows
  }
  insert_OrderItems(objects: $orderItems){
   affected_rows
  }     
}`

export const INSERT_FAILED_RETAIL_SALES = gql`
    mutation failedRetailSales($order: [FailedAutoRetailSales_insert_input!]!){
        insert_FailedAutoRetailSales(objects: $order) {
            returning{id}
        }
    }
`
/* ------------------------------------------------------------- */
